var map = {
	"./modules/seguro-colectivo/seguro-colectivo.module.ngfactory": [
		"./src/app/modules/seguro-colectivo/seguro-colectivo.module.ngfactory.js",
		"default~modules-seguro-colectivo-seguro-colectivo-module-ngfactory~modules-seguro-individual-seguro-~afaa634a",
		"default~modules-seguro-colectivo-seguro-colectivo-module-ngfactory~modules-seguro-salud-seguro-salud~aeaa477b",
		"modules-seguro-colectivo-seguro-colectivo-module-ngfactory"
	],
	"./modules/seguro-individual/seguro-individual.module.ngfactory": [
		"./src/app/modules/seguro-individual/seguro-individual.module.ngfactory.js",
		"default~modules-seguro-colectivo-seguro-colectivo-module-ngfactory~modules-seguro-individual-seguro-~afaa634a",
		"modules-seguro-individual-seguro-individual-module-ngfactory"
	],
	"./modules/seguro-privado/seguro-privado.module.ngfactory": [
		"./src/app/modules/seguro-privado/seguro-privado.module.ngfactory.js",
		"modules-seguro-privado-seguro-privado-module-ngfactory"
	],
	"./modules/seguro-salud/seguro-salud.module.ngfactory": [
		"./src/app/modules/seguro-salud/seguro-salud.module.ngfactory.js",
		"default~modules-seguro-colectivo-seguro-colectivo-module-ngfactory~modules-seguro-salud-seguro-salud~aeaa477b",
		"modules-seguro-salud-seguro-salud-module-ngfactory"
	],
	"./modules/seguro-vitalicio/seguro-vitalicio.module.ngfactory": [
		"./src/app/modules/seguro-vitalicio/seguro-vitalicio.module.ngfactory.js",
		"modules-seguro-vitalicio-seguro-vitalicio-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;